import { PageShell } from "@/components/PageShell";
import { BcNextSection } from "@/components/BcNextSection";
import { BCNEXT_LOGO, BCNEXT_URL } from "@/components/BcNextStrip";
import { StoryInvite } from "@/components/HomeSections";
import { useSeo } from "@/hooks/useSeo";

export default function PartnerPage() {
  useSeo({
    title: "Partner tecnologico BC Next — DonnaImpresa",
    description:
      "DonnaImpresa è progettato e sviluppato da BC Next, società di consulenza IT e sviluppo software: identità, piattaforma sicura e crescita digitale della rete.",
    path: "/partner",
  });

  return (
    <PageShell testId="partner-page">
      <section className="mx-auto max-w-[1400px] px-5 pt-10 sm:px-10">
        <div className="flex flex-wrap items-center gap-6">
          <img
            src={BCNEXT_LOGO}
            alt="Logo BC Next"
            data-testid="partner-bcnext-logo"
            className="h-20 w-20 rounded-2xl bg-[#0E1116] object-contain p-3"
          />
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#E0708A]">
              Partner tecnologico
            </p>
            <h1 className="mt-2 font-display text-4xl tracking-tight text-[#1A1617] sm:text-5xl">
              BC NEXT
            </h1>
            <a
              href={BCNEXT_URL}
              target="_blank"
              rel="noreferrer"
              className="mt-2 inline-block text-sm text-[#5E2A52] di-underline"
              data-testid="partner-bcnext-link"
            >
              bcnext.it
            </a>
          </div>
        </div>
      </section>
      <BcNextSection />
      <StoryInvite />
    </PageShell>
  );
}
